// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offer-form":"offer-form___3OEXV","row":"row___1kq62","full":"full___1e86j","half":"half___lTvUs"};